import React from "react";
import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getProfilePosts } from "../api/getProfilePosts";

const PER_PAGE = 30;

class ProfilePostsContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, items: [], favTags: [] };
  }
  componentWillReceiveProps(nextProps) {
    const { slug: nextSlug } = nextProps;
    const { slug } = this.props;
    if (nextSlug !== slug) {
      this.fetch(nextSlug, 1);
    }
  }
  fetch = (slug, page) => {
    this.props
      .request(slug, page)
      .then(({ data }) => {
        const hasMore = data && data.posts.length === PER_PAGE;
        const items = this.state.items.slice(0);
        data.posts.map((t) => items.push(t));
        const chimneyName = (data && data.chimney) || "";
        const favTags = (data && data.favorite_tags) || "";
        this.setState({ items, chimneyName, favTags, page: (this.state.page += 1), hasMore });
      })
      .then(() => (this.state.page === 1 ? window.scrollTo(0, 0) : null));
  };
}

ProfilePostsContainer.defaultProps = {};
export default CreateContainer(getProfilePosts, ProfilePostsContainer);
